import React from "react";

const TcsExperience = () => {
  return (
    <div className="row  pt-1 text-white">
      <div className="col-sm-12 col-md-12 mt-3">
        <h3>
          System Engineer{" "}
          <span className="font-weight-bold newOrangeDarkStyle">@TCS</span>
        </h3>

        <ul>
          <li>
            Managed GDPR on-boarding at an organizational level, ensuring
            compliance and potentially
            <span className="font-weight-bold">
              {" "}
              saving 4% of global turnover or a 20 Million Euro fine{" "}
            </span>
            through the implementation of a Data Privacy Application (DPA)
          </li>
          <li>
            <span className="font-weight-bold">
              Increased onboarding of applications,
            </span>{" "}
            within an organization for GDPR by
            <span className="font-weight-bold">
            {" "}25% by implementing the(DPIA) feature.
            </span>
          </li>
          <li>
            <span className="font-weight-bold">
              Enhanced user experience by 20%{" "}
            </span>
            by implementing a user-friendly
            <span className="font-weight-bold">
            {" "}Data Attribute Model feature using D3.js{" "}
            </span>
            within the DPA
          </li>
          <li>
            <span className="font-weight-bold">
              Specialized in React.js, Java, Spring Boot, and PostgreSQL
            </span>{" "}
            with a primary focus on these technologies in project development.
            Projects
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TcsExperience;
